export default __webpack_public_path__ + "static/media/bg-roadmap.2f4ecf26.png";